import React from 'react';
import _ from 'lodash';
import {Loader, Grid, Segment, Card, Icon, Header, Button} from 'semantic-ui-react';
import moment from 'moment';
import {Alert} from 'componentLibrary';
import {connect} from 'react-redux';
import ApiActions from 'go/actions/api';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {isValidDuns, isStringOfNumbers, toStartCase} from 'common/utils';
import CreateSubOrganizationForm from 'go/components/organization/subOrganization/createSubOrganizationForm';
import SuborgProgram from 'app-ui-componentlibrary/dist/go/components/common/SuborgProgram';
import {
  API_CREATE_ORG_REQUEST,
  API_CREATE_ORG_FAILURE,
  API_ORG_PROGRAM_GET_SUCCESS,
  API_PROGRAM_LIST_GET_SUCCESS,
} from 'common/types';
import REST from 'go/requests/rest';

const MODAL_OPTIONS = {
  CREATE: 'create',
  NONE: 'none',
  SUCCESS: 'success',
};
const SEARCH_OPTIONS = {
  INITIAL: 'start',
  IN_PROGRESS: 'inprogress',
  FOUND: 'found',
  NOT_FOUND: 'notfound',
  ERROR: 'error',
};
const OrganizationCard = ({successType, organization, programNameList}) =>
  (organization !== undefined && organization.mailingAddress !== null) ||
  organization.addresses[0] !== null ? (
    <div>
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Header as="h3">
              {organization.displayName || organization.legalBusinessName}
            </Header>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={2}>
          <Grid.Column>
            <span className="orgInfo-header">DUNS#</span>
            <div className="orgInfo-data">
              {organization.duns}
              {organization.eft}
            </div>
          </Grid.Column>
          <Grid.Column>
          </Grid.Column>
        </Grid.Row>
        {successType ? (
          <div className="program-grid-row">
            <Grid.Row>
              <Header as="h5">Assigned programs :</Header>
            </Grid.Row>
            <Grid.Row className="programs-row">
              <Grid.Column>
                {_.map(programNameList, (program, index) => {
                  return (
                    <div className="program-value" key={index}>
                      {program} <br />
                    </div>
                  );
                })}
              </Grid.Column>
            </Grid.Row>
          </div>
        ) : null}
      </Grid>
    </div>
  ) : (
    ''
  );
export class OrganizationAndSamProfileCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: MODAL_OPTIONS.NONE,
      isLoaded: false,
      orgData: this.props.data,
      editSub: false,
      errorPayload: false,
      programs: [],
      programCheckedList: [],
      disabledProgramCheckedList: [],
      programNameList: [],
      programSelected: false,
    };
  }

  UNSAFE_componentWillMount() {
    this.props.location !== '/organizationsPage' &&
    this.props.location !== '/organizationsPage/'
      ? this.getProgramData(
          this.props.token,
          this.props.getOrgPrograms,
          this.props.getProgramInfo,
          this.props.orgId,
          this.props.subOrgId
        )
      : '';
  }

  getSubOrganizationInfo(token, orgId, subOrgId) {
    const {data} = this.props;
    this.setState({isLoaded: false});
    try {
      REST.organization
        .getSubOrganization(token, orgId, subOrgId)
        .then(REST.handler.handleResponse)
        .then((res) => {
          data.organizationContacts = res.organizationContacts;
          this.setState({data});
          this.setState({isLoaded: true});
        });
    } catch (err) {
      console.log(err);
      this.setState({isLoaded: true});
    }
  }

  filterPrograms = (programs) => {
    const useSuborgToggle = _.get(this.props, 'toggles', []).includes(
      'useSuborganization'
    );
    let programListFiltered = _.filter(programs, (program) => {
      if (useSuborgToggle) {
        if (program.subapplicationFlag || program.useSuborganizationFlag) {
          return program;
        }
      } else {
        if (program.subapplicationFlag) {
          return program;
        }
      }
    });
    return programListFiltered;
  };

  getProgramData(token, getOrgPrograms, getProgramInfo, orgId, subOrgId) {
    try {
      REST.organizationRelationship
        .getSubOrgProgramsByParentOrgIdAndSubOrgId(token, orgId, subOrgId)
        .then(REST.handler.handleResponse)
        .then((payload) => {
          let idList = [];
          _.map(payload, (program) => {
            idList.push(program.programId);
          });
          this.setState({programCheckedList: idList, disabledProgramCheckedList: idList});
        })
        .then((res) => {
          getOrgPrograms(token, orgId).then((res) => {
            const programs = res.payload;

            // so make sure you are a parent org for this program, you may only be able to manage perms for it.
            let parentPrograms = _.filter(
              programs,
              (program) =>
                !_.has(program, 'parentOrganizations') ||
                _.get(program, 'parentOrganizations.0.organizationId') == orgId
            );
            let ids = new Set(
              _.map(parentPrograms, (program) => {
                return program.programId;
              })
            );

            let params = Array.from(ids).toString();
            getProgramInfo(token, params)
              .then((res) => {
                if (res) {
                  let programs = res.payload;
                  let programsFiltered = this.filterPrograms(programs);
                  programs = _.orderBy(programsFiltered, ['programName'], ['asc']);
                  let programIdList = [];
                  _.map(programs, (program) => {
                    programIdList.push(program.programId);
                  });
                  this.setState({
                    programs,
                    programIdList,
                  });
                }
              })
              .then((res) => {
                const {programs} = this.state;
                let preSelectedPrograms = [];
                let programNameList = [];
                _.map(programs, (program) => {
                  let includesInDisabledProgramList = _.includes(
                    this.state.disabledProgramCheckedList,
                    program.programId
                  );
                  if (includesInDisabledProgramList) {
                    preSelectedPrograms.push(program);
                    programNameList.push(
                      program.programDescription + ' (' + program.programName + ')'
                    );
                  }
                });
                this.setState({preSelectedPrograms});
                this.setState({programNameList});
              });
          });
        });
    } catch (err) {
      console.log(err);
    }
  }

  handleSelectProgram = (e, categoryId, programCheckedList, programNameList) => {
    const {checked} = e.target;
    const useSuborgToggle = _.get(this.props, 'toggles', []).includes(
      'useSuborganization'
    );
    let collection = [];
    let nameCollection = [];
    if (!useSuborgToggle) {
      if (checked) {
        collection = this.handleGetAllPrograms();
        nameCollection = this.handleGetAllProgramsName();
      } else {
        collection = this.handlePreSelectedPrograms();
      }
      this.setState({
        programCheckedList: collection,
        programNameList: nameCollection,
        programSelected: checked,
      });
    } else {
      const disabledProgamsList = this.getDisabledProgamsList();
      const disabledCheckList = disabledProgamsList.map((p) => p.programId);
      const disabledNameList = disabledProgamsList.map((p) => p.programName);
      if (checked) {
        const programsToAdd = _.filter(
          categoryId.programsList,
          (program) =>
            !programCheckedList.includes(program.programId) ||
            !disabledCheckList.includes(program.programId)
        ).map((p) => p.programId);
        const programNamesToAdd = _.filter(categoryId.programsList, (program) =>
          programsToAdd.includes(program.programId)
        ).map((p) => p.programName);
        this.setState({
          programCheckedList: _.concat(programCheckedList, programsToAdd),
          programNameList: _.concat(programNameList, programNamesToAdd),
        });
      } else {
        const programsToRemove = categoryId.programsList.map((p) => p.programId);
        const programNamesToRemove = categoryId.programsList.map((p) => p.programName);
        const newProgramCheckedList = _.filter(
          programCheckedList,
          (p) => !programsToRemove.includes(p) || disabledCheckList.includes(p)
        );
        const newProgramNameList = _.filter(
          programNameList,
          (p) => !programNamesToRemove.includes(p) || disabledNameList.includes(p)
        );
        this.setState({
          programCheckedList: newProgramCheckedList,
          programNameList: newProgramNameList,
        });
      }
    }
  };

  getDisabledProgamsList = () => {
    const {disabledProgramCheckedList, programs} = this.state;
    const programsList = _.filter(programs, (program) =>
      disabledProgramCheckedList.includes(program.programId)
    ).map(({programId, programName}) => ({programId, programName}));

    return programsList;
  };

  handlePreSelectedPrograms = () => {
    const {programs} = this.state;
    let preSelectedPrograms = [];
    _.map(programs, (program) => {
      let includesInDisabledProgramList = _.includes(
        this.state.disabledProgramCheckedList,
        program.programId
      );
      if (includesInDisabledProgramList) {
        preSelectedPrograms.push(program);
      }
    });
    this.setState({preSelectedPrograms});
    const collection = [];
    for (const prog of preSelectedPrograms) {
      collection.push(prog.programId);
      collection.push(prog.programDescription + ' (' + prog.programName + ')');
    }
    return collection;
  };
  handleGetAllPrograms = () => {
    const {programs} = this.state;
    const collection = [];
    for (const prog of programs) {
      collection.push(prog.programId);
    }
    return collection;
  };

  handleGetAllProgramsName = () => {
    const {programs} = this.state;
    const collection = [];
    for (const prog of programs) {
      collection.push(prog.programDescription + ' (' + prog.programName + ')');
    }
    return collection;
  };

  isPassthroughSelected = () => {
    const {programs, programCheckedList, disabledProgramCheckedList} = this.state;
    const useSuborgToggle = _.get(this.props, 'toggles', []).includes(
      'useSuborganization'
    );
    const programsList = _.filter(
      programs,
      (program) =>
        program.subapplicationFlag &&
        programCheckedList.includes(program.programId) &&
        !disabledProgramCheckedList.includes(program.programId)
    ).map((program) => program.programId);

    if (!useSuborgToggle) {
      return false;
    } else {
      return !_.isEmpty(programsList);
    }
  };

  getSelectedDirectPrograms = () => {
    const useSuborgToggle = _.get(this.props, 'toggles', []).includes(
      'useSuborganization'
    );
    const {programs, programCheckedList, disabledProgramCheckedList} = this.state;
    if (useSuborgToggle) {
      const programList = _.filter(
        programs,
        (program) =>
          programCheckedList.includes(program.programId) &&
          !disabledProgramCheckedList.includes(program.programId)
      );
      const directFilteredList = _.filter(programList, (program) => {
        if (program.useSuborganizationFlag) {
          return program;
        }
      });
      if (!_.isEmpty(directFilteredList)) {
        return directFilteredList;
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  readOnlySarSection = () => {
    const {disabledProgramCheckedList, programs} = this.state;
    const programsList = _.filter(
      programs,
      (program) =>
        program.subapplicationFlag &&
        disabledProgramCheckedList.includes(program.programId)
    ).map((program) => program.programId);

    return !_.isEmpty(programsList);
  };

  handleProgramCheckbox = (e) => {
    const {value, checked, name} = e.target;
    if (checked) {
      const collection = this.handleGetAllPrograms();
      const nameCollection = this.handleGetAllProgramsName();
      this.setState((prevState) => ({
        programCheckedList: [...prevState.programCheckedList, value * 1],
        programNameList: [...prevState.programNameList, name],
        programSelected: collection.length === prevState.programCheckedList.length + 1,
      }));
    } else {
      this.setState((prevState) => ({
        programCheckedList: _.filter(
          prevState.programCheckedList,
          (item) => item != value
        ),
        programNameList: _.filter(prevState.programNameList, (item) => item != name),
        programSelected: false,
      }));
    }
  };

  formatAdress = (address) => {
    if (address) {
      return (
        <React.Fragment>
          {toStartCase(_.toLower(address.addressLine1))} <br />
          {address.addressLine2 ? toStartCase(_.toLower(address.addressLine2)) : null}
          {address.addressLine2 ? <br /> : null}
          {toStartCase(_.toLower(address.city))}, {address.stateOrProvince} {address.zip}
        </React.Fragment>
      );
    }
    return;
  };

  handleInputChange = (e) => {
    const {data} = this.props;
    const {id, name, value} = e.target;
    if (id === 'dunsNumber') {
      let split = _.size(value) > 0 ? value.match(/.{1,9}/g) : value;
      data[name] = split[0];
      data['eft'] = split[1];
      this.setState({data});
    } else {
      data[name] = value;
      this.setState({data});
    }
  };

  getProgamListToSend = () => {
    const {toggles} = this.props;
    const {programCheckedList, disabledProgramCheckedList} = this.state;
    const useSuborgToggle = _.includes(toggles, 'useSuborganization');
    const isDirectOnly = this.isDirectProgramsOnlySelected();
    const filteredList = _.filter(
      programCheckedList,
      (program) => !disabledProgramCheckedList.includes(program)
    );
    const emptyArray = [];

    if (useSuborgToggle) {
      if (isDirectOnly) {
        const directList = this.getSelectedDirectPrograms().map((p) => p.programId);
        return directList;
      } else if (_.isEmpty(filteredList)) {
        return emptyArray;
      } else {
        return programCheckedList;
      }
    } else {
      return programCheckedList;
    }
  };

  isDirectProgramsOnlySelected = () => {
    const {programs, disabledProgramCheckedList, programCheckedList} = this.state;
    const useSuborgToggle = _.get(this.props, 'toggles', []).includes(
      'useSuborganization'
    );
    if (useSuborgToggle) {
      const programList = _.filter(
        programs,
        (program) =>
          programCheckedList.includes(program.programId) &&
          !disabledProgramCheckedList.includes(program.programId)
      );
      const directFilteredList = _.filter(programList, (program) => {
        if (program.useSuborganizationFlag) {
          return program;
        }
      });
      if (_.isEmpty(programList)) {
        return false;
      } else if (_.isEqual(programList, directFilteredList)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  handleMailingAddressChange = (e) => {
    const {data} = this.props;
    const {name, value} = e.target;
    let mailingAddress = data.mailingAddress;
    mailingAddress[name] = value;
    data.mailingAddress = mailingAddress;
    this.setState({data});
  };
  handlePhysicalAddressChange = (e) => {
    const {data} = this.props;
    const {name, value} = e.target;
    let physicalAddress = data.physicalAddress;
    physicalAddress[name] = value;
    data.physicalAddress = physicalAddress;
    this.setState({data});
  };

  setEmptyContacts = () => {
    const {data} = this.props;
    if (_.isEmpty(data.organizationContacts)) {
      const emptyOrgContact = {
        prefix: '',
        suffix: '',
        firstName: '',
        middleInitial: '',
        lastName: '',
        title: '',
        email: '',
        usPhone: '',
        usPhoneExtension: '',
        nonUSPhone: '',
        fax: '',
        type: 'ELECTRONIC',
        address: {
          addressLine1: '',
          addressLine2: '',
          city: '',
          stateOrProvince: '',
          zip: '',
          zipPlus4: '',
          county: '',
          country: '',
          type: null,
        },
      };
      let path = {
        organizationContact: {
          contact: emptyOrgContact,
        },
      };
      data.organizationContacts[0] = path;
      this.setState({data});
    }
  };

  handleSarChange = (e) => {
    const {data} = this.props;
    const {name, value} = e.target;
    let path = {
      organizationContact: {
        contact: {},
      },
    };
    if (_.isEmpty(data.organizationContacts)) {
      this.setEmptyContacts();
    }
    let contacts = data.organizationContacts[0].organizationContact.contact;
    if (name === 'salutationType') {
      contacts['prefix'] = value;
    } else {
      contacts[name] = value;
    }
    path.organizationContact.contact = contacts;
    data.organizationContacts[0] = path;
    this.setState({data});
  };

  renderEditSuborgModal() {
    const {data, orgId, toggles} = this.props;
    const useSuborgToggle = _.includes(toggles, 'useSuborganization');
    const dunsToUEIToggle = _.includes(toggles, 'dunsToUEI');
    const displayContactInfo = useSuborgToggle && !_.isEmpty(data.organizationContacts);
    return (
      <React.Fragment>
        <CreateSubOrganizationForm
          organizationName={data.displayName}
          dunsNumber={data.duns}
          einNumber={data.ein}
          city={data.mailingAddress.city}
          zipCode={data.mailingAddress.zip}
          runValidation={this.runValidation}
          addressLine1={data.mailingAddress.addressLine1}
          addressLine2={data.mailingAddress.addressLine2}
          stateOrProvince={data.mailingAddress.state}
          firstName={
            displayContactInfo
              ? _.get(
                  data,
                  'organizationContacts.0.organizationContact.contact.firstName'
                )
              : null
          }
          lastName={
            displayContactInfo
              ? _.get(data, 'organizationContacts.0.organizationContact.contact.lastName')
              : null
          }
          middleInitial={
            displayContactInfo
              ? _.get(
                  data,
                  'organizationContacts.0.organizationContact.contact.middleName'
                )
              : null
          }
          email={
            displayContactInfo
              ? _.get(data, 'organizationContacts.0.organizationContact.contact.email')
              : null
          }
          prefix={
            displayContactInfo
              ? _.get(data, 'organizationContacts.0.organizationContact.contact.prefix')
              : null
          }
          suffix={
            displayContactInfo
              ? _.get(data, 'organizationContacts.0.organizationContact.contact.suffix')
              : null
          }
          errorPayload={this.state.errorPayload}
          createOrgPostPayload={this.createOrgPostPayload}
          orgData={data}
          orgId={orgId}
          displayError={false}
          dunsToUEIToggle={dunsToUEIToggle}
          isSuborgUpdate={true}
          isEditable={true}
          title="Update this suborganization"
          handleInputChange={this.handleInputChange}
          handleMailingAddressChange={this.handleMailingAddressChange}
          handlePhysicalAddressChange={this.handlePhysicalAddressChange}
          handleSarChange={this.handleSarChange}
          displayDirectPrograms={this.getSelectedDirectPrograms()}
          isUpdate={true}
        />
      </React.Fragment>
    );
  }
  createOrgPostPayload = (orgPayload, programCheckedList, programNameList) => {
    const {data, orgId, toggles} = this.props;
    this.setState({programCheckedList: programCheckedList});
    this.setState({programNameList: programNameList});
    const useSuborgToggle = _.includes(toggles, 'useSuborganization');
    const programsList = this.getProgamListToSend();
    const sendContacts = useSuborgToggle && !_.isEmpty(data.organizationContacts);
    const {duns, dunsNumberPlus4, dunsPlus4, ein, isManuallyAdded, displayName} = data;
    const payload = {
      programIds: isManuallyAdded === 'N' ? programCheckedList : programsList,
      legalBusinessName: displayName,
      duns: duns || '',
      dunsPlus4: dunsPlus4 || '',
      dunsNumberPlus4: dunsNumberPlus4 || '',
      ein: ein,
      contacts:
        isManuallyAdded === 'N'
          ? undefined
          : sendContacts
          ? [data.organizationContacts[0].organizationContact.contact]
          : undefined,
      isManuallyAdded: isManuallyAdded,
      mailingAddress: {
        addressId: data.mailingAddress.addressId,
        addressLine1: data.mailingAddress.addressLine1,
        addressLine2: data.mailingAddress.addressLine2
          ? data.mailingAddress.addressLine2
          : undefined,
        city: data.mailingAddress.city,
        stateOrProvince: data.mailingAddress.stateOrProvince,
        zip: data.mailingAddress.zip,
        zipPlus4: data.mailingAddress.zipPlus4,
        county: data.mailingAddress.county,
        country: null,
        type: 'MAILING',
      },
      physicalAddress: {
        addressId: data.physicalAddress.addressId,
        addressLine1: data.physicalAddress.addressLine1,
        addressLine2: data.physicalAddress.addressLine2
          ? data.physicalAddress.addressLine2
          : undefined,
        city: data.physicalAddress.city,
        stateOrProvince: data.physicalAddress.stateOrProvince,
        zip: data.physicalAddress.zip,
        zipPlus4: data.physicalAddress.zipPlus4,
        county: data.physicalAddress.county,
        country: null,
        type: 'PHYSICAL',
      },
    };
    this.handleUpdateOrganization(payload);
  };
  handleUpdateOrganization = async (orgPayload) => {
    const {token, organizationId, orgId, subOrgId} = this.props;
    const payload = orgPayload;
    let result;

    REST.organization
      .updateSubOrganization(token, orgId, subOrgId, orgPayload)
      .then((payload) => {
        if (payload.ok) {
          this.setState({
            openModal: MODAL_OPTIONS.SUCCESS,
            newOrganizationInfo: payload.organization,
          });
        } else {
          const validated = {programCheckedList: 'Error updating subOrganization'};
          this.setState({
            errorPayload: validated,
          });
        }
      });
  };
  runValidation = () => {
    const {data, orgId} = this.props;
    const useSuborgToggle = _.get(this.props, 'toggles', []).includes(
      'useSuborganization'
    );
    const isPassthrough = this.isPassthroughSelected();
    const existingSar = this.readOnlySarSection();
    const runSarValidation = useSuborgToggle && isPassthrough && !existingSar;
    let validated = {};

    if (runSarValidation && _.isEmpty(data.organizationContacts)) {
      this.setEmptyContacts();
    }

    if (_.isEmpty(data.displayName)) {
      validated.legalBusinessName = 'Please enter organization name.';
    }

    if (!_.isEmpty(data.duns)) {
      isValidDuns(data.duns)
        ? ''
        : (validated.dunsNumber = 'Please enter a valid 9 or 13 digit number.');
    }
    if (_.isEmpty(data.mailingAddress.addressLine1)) {
      validated.addressLine1 = 'Please enter address.';
    }
    _.isEmpty(data.mailingAddress.city) ? (validated.city = 'Please enter city.') : '';
    if (_.isEmpty(data.mailingAddress.stateOrProvince)) {
      validated.stateOrProvince = 'Please select state.';
    }
    _.isEmpty(data.mailingAddress.zip)
      ? (validated.zip = 'Please enter zip code.')
      : isStringOfNumbers(data.mailingAddress.zip)
      ? (validated.zip = 'Please use numbers.')
      : '';
    if (_.isEmpty(data.physicalAddress.addressLine1)) {
      validated.physical_addressLine1 = 'Please enter address.';
    }
    _.isEmpty(data.physicalAddress.city)
      ? (validated.physical_city = 'Please enter city.')
      : '';
    if (_.isEmpty(data.physicalAddress.stateOrProvince)) {
      validated.physical_stateOrProvince = 'Please select state.';
    }
    _.isEmpty(data.physicalAddress.zip)
      ? (validated.physical_zip = 'Please enter zip code.')
      : isStringOfNumbers(data.physicalAddress.zip)
      ? (validated.physical_zip = 'Please use numbers.')
      : '';
    if (runSarValidation) {
      if (_.isEmpty(data.organizationContacts[0].organizationContact.contact.firstName)) {
        validated.firstName = 'Please enter first name.';
      }
      if (_.isEmpty(data.organizationContacts[0].organizationContact.contact.lastName)) {
        validated.lastName = 'Please enter last name.';
      }
      if (_.isEmpty(data.organizationContacts[0].organizationContact.contact.suffix)) {
        validated.title = 'Please enter title.';
      }
      if (_.isEmpty(data.organizationContacts[0].organizationContact.contact.email)) {
        validated.email = 'Please enter email.';
      }
    }
    this.setState({
      errorPayload: validated,
    });
    return validated;
  };

  runValidationForProgams = (programCheckedList, disabledProgramCheckedList) => {
    let validated = {};
    if (_.size(programCheckedList) === _.size(disabledProgramCheckedList)) {
      validated.programCheckedList = 'Please provide required program.';
    }
    this.setState({
      errorPayload: validated,
    });
    return validated;
  };

  addSubOrgHandler = (event) => {
    this.setState({
      openModal: MODAL_OPTIONS.CREATE,
      dunsNumber: '',
      searching: SEARCH_OPTIONS.INITIAL,
      displayError: false,
      errorMessage: '',
    });
  };
  showModal = () => {
    const {data, isLoaded, orgId, toggles} = this.props;
    const useSuborgToggle = _.includes(toggles, 'useSuborganization');
    const dunsToUEIToggle = _.includes(toggles, 'dunsToUEI');

    return (
      <FemaGoModal
        type="alert"
        size="small"
        className="modal-title"
        open={this.state.openModal === MODAL_OPTIONS.CREATE}
        confirmButton="hidden"
        cancelAction={() =>
          this.setState({
            openModal: MODAL_OPTIONS.NONE,
            errorPayload: {},
            responseErrorMessage: '',
            programCheckedList: this.state.disabledProgramCheckedList,
            programNameList: this.state.preSelectedPrograms.map((p) => p.programName),
          })
        }
        closeOnDimmerClick="no"
      >
        <br />
        <CreateSubOrganizationForm
          organizationName={data.displayName}
          dunsNumber={data.duns}
          einNumber={data.ein}
          city={data.mailingAddress.city}
          zipCode={data.mailingAddress.zip}
          runValidation={this.runValidation}
          addressLine1={data.mailingAddress.addressLine1}
          addressLine2={data.mailingAddress.addressLine2}
          stateOrProvince={data.mailingAddress.state}
          errorPayload={this.state.errorPayload}
          createOrgPostPayload={this.createOrgPostPayload}
          preSelectedPrograms={this.state.preSelectedPrograms}
          orgData={data}
          orgId={orgId}
          displayError={false}
          isSuborgUpdate={false}
          isEditable={true}
          title="Update this suborganization"
          handleInputChange={this.handleInputChange}
          handleMailingAddressChange={this.handleMailingAddressChange}
          handlePhysicalAddressChange={this.handlePhysicalAddressChange}
          isUpdate={true}
          editMode={true}
          handlePrograms={this.handlePrograms}
          programs={this.state.programs}
          programCheckedList={this.state.programCheckedList}
          programSelected={this.state.programSelected}
          handleProgramCheckbox={this.handleProgramCheckbox}
          handleSelectProgram={this.handleSelectProgram}
          handleGetAllPrograms={this.handleGetAllPrograms}
          disabledProgramCheckedList={this.state.disabledProgramCheckedList}
          disableAORSection={!this.isPassthroughSelected()}
          programNameList={this.state.programNameList}
          useSuborgToggle={useSuborgToggle}
          dunsToUEIToggle={dunsToUEIToggle}
          editSuborg={true}
          handleSarChange={this.handleSarChange}
          editSarSection={!this.readOnlySarSection()}
          readOnlySarSection={this.readOnlySarSection()}
          displayDirectPrograms={this.getSelectedDirectPrograms()}
        />
      </FemaGoModal>
    );
  };
  toggleSuccessModal = () => {
    const {orgData, openModal, programCheckedList, programNameList} = this.state;
    return (
      <FemaGoModal
        type="alert"
        size="small"
        title={orgData.displayName + ' is successfully updated'}
        className="modal-title"
        open={openModal === MODAL_OPTIONS.SUCCESS}
        confirmButton="hidden"
        cancelAction={() => {
          this.setState({
            openModal: MODAL_OPTIONS.NONE,
          });
          this.props.handleOrgChange(this.props.orgId, this.props.subOrgId);
          this.getProgramData(
            this.props.token,
            this.props.getOrgPrograms,
            this.props.getProgramInfo,
            this.props.orgId,
            this.props.subOrgId
          );
          this.getSubOrganizationInfo(
            this.props.token,
            this.props.orgId,
            this.props.subOrgId
          );
        }}
        cancelButtonText="Close"
        closeOnDimmerClick="no"
      >
        <Alert
          size="tiny"
          header="The following suborganization has been successfully updated "
          type="success"
          dismissable={false}
        >
          <br />
          <OrganizationCard
            successType={true}
            organization={orgData}
            programNameList={programNameList}
          />
        </Alert>
      </FemaGoModal>
    );
  };

  showProgamModal = () => {
    const {data, isLoaded, orgId, toggles} = this.props;
    const useSuborgToggle = _.includes(toggles, 'useSuborganization');
    return (
      <FemaGoModal
        type="alert"
        size="small"
        className="modal-title"
        open={this.state.openModal === MODAL_OPTIONS.CREATE}
        confirmButton="hidden"
        cancelAction={() =>
          this.setState({
            openModal: MODAL_OPTIONS.NONE,
            errorPayload: {},
            responseErrorMessage: '',
            programCheckedList: this.state.disabledProgramCheckedList,
            programNameList: this.state.preSelectedPrograms.map((p) => p.programName),
          })
        }
        closeOnDimmerClick="no"
      >
        <React.Fragment>
          <SuborgProgram
            useSuborgToggle={useSuborgToggle}
            programs={this.state.programs}
            programCheckedList={this.state.programCheckedList}
            programNameList={this.state.programNameList}
            programSelected={this.state.programSelected}
            disabledProgramCheckedList={this.state.disabledProgramCheckedList}
            handlePrograms={this.handlePrograms}
            handleProgramCheckbox={this.handleProgramCheckbox}
            handleSelectProgram={this.handleSelectProgram}
            handleGetAllPrograms={this.handleGetAllPrograms}
            displayError={
              this.state.errorPayload && this.state.errorPayload.programCheckedList
            }
            errorMessage={
              this.state.errorPayload && this.state.errorPayload.programCheckedList
            }
          />
          <Button
            primary
            icon
            id="viewSubOrganization_update"
            title="Update this suborganization"
            onClick={() => {
              let validation = this.runValidationForProgams(
                this.state.programCheckedList,
                this.state.disabledProgramCheckedList
              );
              if (_.isEmpty(validation)) {
                this.createOrgPostPayload(
                  this.props.data,
                  this.state.programCheckedList,
                  this.state.programNameList
                );
              }
            }}
          >
            Update this suborganization&nbsp;&nbsp;
            <Icon name="checkmark" fitted />
          </Button>
        </React.Fragment>
      </FemaGoModal>
    );
  };
  getUEIFormatting = (data) => {
    return `${data.uei ? data.uei : null}${
      data.uei && data.eft && _.trim(data.eft) != '' ? '-' + data.eft : ''
    }`;
  };
  renderSummaryCard() {
    const {data, isLoaded, mainLabel, isUserAOR, toggles} = this.props;
    const dunsToUEIToggle = _.includes(toggles, 'dunsToUEI');
    const isSubOrg = mainLabel === 'Sub Organization information';
    const isManuallyAdded = data.isManuallyAdded === 'Y';
    const shouldEdit = isSubOrg && isUserAOR && !isManuallyAdded;
    const useSuborgToggle = _.includes(toggles, 'useSuborganization');
    const displayEditProgsForSam =
      isSubOrg && isUserAOR && !isManuallyAdded && useSuborgToggle;
    const disabledProgramList = this.getDisabledProgamsList();
    return (
      <Card fluid>
        {isLoaded ? (
          <React.Fragment>
            <Card.Content>
              <Grid id="SummaryInfo">
                <Grid.Row>
                  <Grid.Column mobile={8} computer={4}>
                    <h5 className="underlined-card-label">Summary information</h5>
                  </Grid.Column>
                  {!shouldEdit && isSubOrg && isUserAOR ? (
                    <Grid.Column
                      floated="right"
                      textAlign="right"
                      mobile={8}
                      computer={4}
                    >
                      <React.Fragment>
                        <a
                          id="edit-details"
                          href="#"
                          onClick={(e) => this.addSubOrgHandler(e)}
                        >
                          <Icon link name="pencil" color="blue" />
                          Edit
                        </a>

                        {this.showModal()}
                        {this.toggleSuccessModal()}
                      </React.Fragment>
                    </Grid.Column>
                  ) : (
                    ''
                  )}
                  {displayEditProgsForSam && (
                    <Grid.Column
                      floated="right"
                      textAlign="right"
                      mobile={8}
                      computer={4}
                    >
                      <React.Fragment>
                        <a
                          id="edit-details"
                          href="#"
                          onClick={(e) => this.addSubOrgHandler(e)}
                        >
                          <Icon link name="pencil" color="blue" />
                          Edit
                        </a>
                        {this.showProgamModal()}
                        {this.toggleSuccessModal()}
                      </React.Fragment>
                    </Grid.Column>
                  )}
                </Grid.Row>
                <Grid.Row>
                  {data.mailingAddress && (
                    <Grid.Column mobile={8} computer={4}>
                      <div className="org-address textSmall">
                        <strong>Mailing address</strong>
                        <br />
                        {this.formatAdress(data.mailingAddress)}
                      </div>
                    </Grid.Column>
                  )}
                  {data.physicalAddress && (
                    <Grid.Column mobile={8} computer={4}>
                      <div className="org-address textSmall">
                        <strong>Physical address</strong>
                        <br />
                        {this.formatAdress(data.physicalAddress)}
                      </div>
                    </Grid.Column>
                  )}
                  {data.duns && (
                    <Grid.Column mobile={8} computer={2}>
                      <div className="duns-number textSmall">
                        <strong>DUNS#</strong>
                        <br />
                        {data.duns}
                        {data.eft}
                      </div>
                    </Grid.Column>
                  )}
                  {dunsToUEIToggle && (
                    <Grid.Column mobile={8} computer={4}>
                      <div className="uei-number textSmall">
                        <strong>UEI-EFT</strong>
                        <br />
                        {data.uei ? this.getUEIFormatting(data) : '--'}
                      </div>
                    </Grid.Column>
                  )}
                </Grid.Row>
              </Grid>
              <Grid id="SamInfo">
                <div className="card-label-wrapper">
                  <h5 className="underlined-card-label">SAM.gov information</h5>
                </div>
                {data.isManuallyAdded === 'Y' && (
                  <span>
                    Your organization is not currently registered on System for Award
                    Management(SAM.gov).
                  </span>
                )}
                <Grid.Row>
                  {data.isManuallyAdded === 'N' && (
                    <Grid.Column mobile={8} computer={8}>
                      <div className="doing-business-as-name textSmall">
                        <strong>Doing business as name</strong>
                        <br />
                        <strong className="textMedium">
                          {data.doingBusinessAs ? data.doingBusinessAs : '--'}
                        </strong>
                      </div>
                    </Grid.Column>
                  )}
                  {data.isManuallyAdded === 'N' && (
                    <Grid.Column mobile={8} computer={4}>
                      <div className="registeration-summary textSmall">
                        <strong>Registration status</strong>
                        <br />
                        {data.samRegistrationStatus
                          ? data.samRegistrationStatus.name
                          : '--'}
                      </div>
                    </Grid.Column>
                  )}
                </Grid.Row>
                <Grid.Row>
                  {data.isManuallyAdded === 'N' && (
                    <Grid.Column mobile={8} computer={4}>
                      <div className="Registration-last-update-date textSmall">
                        <strong>Registration last updated date</strong>
                        <br />
                        {data.samLastUpdateDate
                          ? moment(data.samLastUpdateDate).format('MM/DD/YYYY')
                          : '--'}
                      </div>
                    </Grid.Column>
                  )}
                  {data.isManuallyAdded === 'N' && (
                    <Grid.Column mobile={8} computer={4}>
                      <div className="registeration-expiration-date textSmall">
                        <strong>Registration expiration date</strong>
                        <br />
                        {data.samExpirationDate
                          ? moment(data.samExpirationDate).format('MM/DD/YYYY')
                          : '--'}
                      </div>
                    </Grid.Column>
                  )}
                  {data.isManuallyAdded === 'N' && (
                    <Grid.Column mobile={8} computer={4}>
                      <div className="has-active-exclusion textSmall">
                        <strong>Has active exclusion?</strong>
                        <br />
                        {data.samExclusionStatus ? data.samExclusionStatus : '--'}
                      </div>
                    </Grid.Column>
                  )}
                  {data.isManuallyAdded === 'N' && (
                    <Grid.Column mobile={8} computer={4}>
                      <div className="debt-subject-to-offset textSmall">
                        <strong>Debt subject to offset?</strong>
                        <br />
                        {data.debtSubjectToOffset ? data.debtSubjectToOffset : '--'}
                      </div>
                    </Grid.Column>
                  )}
                </Grid.Row>
              </Grid>
              {isSubOrg && useSuborgToggle ? (
                <Grid id="ProgramInfo">
                  <div className="card-label-wrapper">
                    <h5 className="underlined-card-label">Assigned Programs</h5>
                  </div>
                  {_.map(disabledProgramList, (program, index) => {
                    return (
                      <Grid.Row padded={false} key={index}>
                        <Grid.Column>{program.programName}</Grid.Column>
                      </Grid.Row>
                    );
                  })}
                </Grid>
              ) : null}
            </Card.Content>
          </React.Fragment>
        ) : (
          <Card.Content>
            <Loader inline="centered" active>
              Loading...
            </Loader>
          </Card.Content>
        )}
      </Card>
    );
  }

  render() {
    return (
      <Segment>
        <Grid className="org-summary-card">
          {this.state.editSub ? this.renderEditSuborgModal() : this.renderSummaryCard()}
        </Grid>
      </Segment>
    );
  }
}
export const mapDispatchToProps = (dispatch) => ({
  createSubOrganization: (token, payload, orgId) => {
    const action = ApiActions.organization.createSubOrg(token, payload, orgId);
    const response = dispatch(action);
    return response.then((res) => {
      res.hasResults = res.type === API_CREATE_ORG_REQUEST && !_.isEmpty(res.payload); // TODO, how is this working? Shouldn't this be API_CREATE_SUB_ORG_SUCCESS ?
      return res;
    });
  },
  getOrgPrograms: (token, orgId) => {
    const action = ApiActions.organizationRelationship.getAllOrganizationProgramsByOrgId(
      token,
      orgId
    );
    const response = dispatch(action);
    return response;
  },
  getProgramInfo: (token, params) => {
    const action = ApiActions.program.getProgramList(token, params);
    const response = dispatch(action);
    return response;
  },
});
export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    auth: state.auth,
    location: state.router.location.pathname,
    toggles: state.toggles.toggles,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrganizationAndSamProfileCard);
